import api from "../../../api/index";

export function activityLogger(sd, ed, page = "1") {
  return api.get(
    `get-user-log-activity-v2?startDate=${sd}&endDate=${ed}&page=${page}`
  );
}

export function slotBooking(sd, ed){
  
    return api.get(`get-log-activity-stats?startDate=${sd}&endDate=${ed}&booking_type=SLOT_BOOKING`)
}

export function rescheduleSlotBooking(sd, ed){
    return api.get(`get-log-activity-stats?startDate=${sd}&endDate=${ed}&booking_type=RESCHEDULE_SLOT_BOOKING`)
}

export function four99Booking(sd, ed){
    return api.get(`get-log-activity-stats?startDate=${sd}&endDate=${ed}&booking_type=499_BOOKING`)
}

export function four99SlBookingReschedule(sd,ed){
    return api.get(`get-log-activity-stats?startDate=${sd}&endDate=${ed}&booking_type=499_BOOKING_RESHCEDULE`)
}